/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_RemoveInputs */

const en_action_remove = /** @type {(inputs: Action_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const es_action_remove = /** @type {(inputs: Action_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const fr_action_remove = /** @type {(inputs: Action_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer`)
};

const de_action_remove = /** @type {(inputs: Action_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

const ja_action_remove = /** @type {(inputs: Action_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

const zh_action_remove = /** @type {(inputs: Action_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除`)
};

const ar_action_remove = /** @type {(inputs: Action_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إزالة`)
};

const id_action_remove = /** @type {(inputs: Action_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus`)
};

const it_action_remove = /** @type {(inputs: Action_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi`)
};

const ru_action_remove = /** @type {(inputs: Action_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить`)
};

const pt_action_remove = /** @type {(inputs: Action_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover`)
};

const ko_action_remove = /** @type {(inputs: Action_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제거`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Action_RemoveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_remove = /** @type {((inputs?: Action_RemoveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_RemoveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_remove(inputs)
	if (locale === "es") return es_action_remove(inputs)
	if (locale === "fr") return fr_action_remove(inputs)
	if (locale === "de") return de_action_remove(inputs)
	if (locale === "ja") return ja_action_remove(inputs)
	if (locale === "zh") return zh_action_remove(inputs)
	if (locale === "ar") return ar_action_remove(inputs)
	if (locale === "id") return id_action_remove(inputs)
	if (locale === "it") return it_action_remove(inputs)
	if (locale === "ru") return ru_action_remove(inputs)
	if (locale === "pt") return pt_action_remove(inputs)
	return ko_action_remove(inputs)
});